export default __webpack_public_path__ + "static/rosgonki-2d9d643481ed19377feed4a3b6a25c62.svg";